import React from "react";
import { Link } from "react-router-dom";
import logo from "../../Assets/Images/logo/global-it-master-logo-header.jpg";
import profileIMG from "../../Assets/Images/Image/dashboard/profile.png";
const DashboardNav = ({ profile }) => {
  return (
    <div className="sticky shadow-sm bg-[#fff] top-0 bg-base-100 z-50 ">
      <nav className="max-w-[1200px] mx-auto  py-3 px-5 max-xl:px-0">
        <div className="flex justify-between items-center">
          <div>
            <Link to="/">
              <img
                className="max-h-[60px] max-xl:max-h-[70px]"
                src={logo}
                alt="Global IT Master"
              />
            </Link>
          </div>
          <div className="flex items-center">
            <button className="mr-5 relative">
              <div className="indicator">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-[30px] w-[30px]"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                  />
                </svg>
                <span className="bg-[#e62c2c] absolute top-0 inline-block w-[10px] h-[10px] rounded-full"></span>
              </div>
            </button>
            <img
              className="w-[50px] h-[50px] rounded-full"
              src={profile?.photo ? profile?.photo : profileIMG}
              alt="Global IT Master"
            />
          </div>
        </div>
      </nav>
    </div>
  );
};

export default DashboardNav;
